const roles = {
  SUPER_ADMIN: "super admin",
  LOCAL_ADMIN: "local admin",
  APPROVER: "approver",
  WORKER: "worker",
  VENDOR: "vendor",
  FREELANCER: "freelancer",
}
 export default roles;
